import blogo from '../../assets/images/blogo.svg'
import facebook from '../../assets/images/facebook.svg'
import instagram from '../../assets/images/instagram.svg'
import linkdin from '../../assets/images/linkdin.svg'
import youtube from '../../assets/images/youtube.svg'

function Footer() {
    return (
        <footer className="footer bg-light text-dark py-5">
            <div className="w-100">
                <div className="row">
                    {/* Left Section */}
                    <div className="col-md-6 mb-4">
                        {/* Logo */}
                        <img
                            src={blogo}
                            alt="Logo"
                            className="mb-3"
                            style={{ width: "40px", height: "40px" }}
                        />

                        {/* Description */}
                        <p className="small text-muted w-75">
                            Your AI Superagent For Work. Connect your data, ask a prompt, get
                            results.
                        </p>

                        {/* Social Icons */}
                        <div className="d-flex gap-3 fs-4 text-primary mb-3">
                            <a href="#"><img src={facebook} alt="" /></a>
                            <a href="#"><img src={instagram} alt="" /></a>
                            <a href="#"><img src={linkdin} alt="" /></a>
                            <a href="#"><img src={youtube} alt="" /></a>
                        </div>

                        {/* Contact */}
                        <a href="#" className="fw-medium" style={{color:"#38608F"}}>
                            Contact Us
                        </a>
                    </div>

                    {/* Product Column */}
                    <div className="col-md-2 mb-4">
                        <h6 className="fw-bold footer-title">Product</h6>
                        <ul className="list-unstyled small">
                            <li><a href="#" className="footer-menu">Chat With Your Data</a></li>
                            <li><a href="#" className="footer-menu">Interactive Data Viz</a></li>
                            <li><a href="#" className="footer-menu">Connect DBs</a></li>
                            <li><a href="#" className="footer-menu">Brainy Plugin</a></li>
                        </ul>
                    </div>

                    {/* Resources Column */}
                    <div className="col-md-2 mb-4">
                        <h6 className="fw-bold footer-title">Resources</h6>
                        <ul className="list-unstyled small">
                            <li><a href="#" className="footer-menu">Tutorials</a></li>
                            <li><a href="#" className="footer-menu">Wiki</a></li>
                        </ul>
                    </div>

                    {/* Security Column */}
                    <div className="col-md-2 mb-4">
                        <h6 className="fw-bold footer-title">Security</h6>
                        <ul className="list-unstyled small">
                            <li><a href="#" className="footer-menu">Security</a></li>
                            <li><a href="#" className="footer-menu">Trust Center</a></li>
                            <li><a href="#" className="footer-menu">Terms & Conditions</a></li>
                            <li><a href="#" className="footer-menu">Privacy Policy</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer